import { NumberField } from '@base-ui/react/number-field';
import type { ComponentPropsWithRef } from 'react';

import { cn } from '@/lib/utils';

import { useNumberInputContext } from './NumberInputContext';

const sizeClasses = {
  small: cn('rounded-sm'),
  medium: cn('rounded-md'),
  large: cn('rounded-md'),
} satisfies Record<string, string>;

export type NumberInputGroupProps = ComponentPropsWithRef<typeof NumberField.Group>;

const NumberInputGroup = ({ ref, className, ...props }: NumberInputGroupProps) => {
  const { size } = useNumberInputContext();

  return (
    <NumberField.Group
      ref={ref}
      data-slot="number-input-group"
      className={cn(
        'group/number-input-group relative w-full min-w-0 border border-gray-600 bg-white transition-colors outline-none',
        sizeClasses[size],
        'hover:border-gray-900',
        'has-[[data-slot=input-group-control]:focus]:border-green-500',
        'has-[[data-slot=input-group-control]:focus]:ring-1',
        'has-[[data-slot=input-group-control]:focus]:ring-green-500/50',
        'has-[[data-slot=input-group-control][aria-invalid=true]]:border-red-400',
        'has-[[data-slot=input-group-control][aria-invalid=true]]:hover:border-red-500',
        'has-[[data-slot=input-group-control][aria-invalid=true]:focus]:border-red-500',
        'has-[[data-slot=input-group-control][aria-invalid=true]:focus]:ring-1',
        'has-[[data-slot=input-group-control][aria-invalid=true]:focus]:ring-red-500/50',
        'has-[[data-slot=input-group-control]:disabled]:border-gray-400',
        'has-[[data-slot=input-group-control]:disabled]:bg-gray-100',
        'has-[[data-slot=input-group-control]:disabled]:text-gray-500',
        className,
      )}
      {...props}
    />
  );
};

NumberInputGroup.displayName = 'NumberInputGroup';

export default NumberInputGroup;
